import { Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TabLabelProps as Props } from './types';

export const TabLabel = memo(({ className, title, count, active }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('TabLabel', className)}
      sx={SX.root}
      direction="row"
      gap={0.5}
      alignItems="center"
    >
      <Typography variant="body4">{title}</Typography>
      <Label variant="filled" color={active ? 'primary' : 'default'}>
        {count}
      </Label>
    </Styled.Wrapper>
  );
});

TabLabel.displayName = 'TabLabel';
